import { ReactElement } from 'react';

import { useTranslation } from 'modules/i18n';
import { NightlyWalletIcon } from 'modules/icons';

import { WalletId } from '../../const';
import { ConnectButton } from '../ConnectButton';
import { translation } from './translation';

const INSTALL_WALLET_LINK =
  'https://chromewebstore.google.com/detail/nightly/fiikommddbeccaoicoejoniammnalkfa';

export function NightlyWalletConnectButton(): ReactElement {
  const { t, keys } = useTranslation(translation);
  return (
    <ConnectButton
      icon={<NightlyWalletIcon height={36} width={36} />}
      installWalletLink={INSTALL_WALLET_LINK}
      name={t(keys.nightlyWallet)}
      walletId={WalletId.nightly}
    />
  );
}
